import React from "react";
import { FiMail } from "react-icons/fi";
import OutboundTestForm from "../components/OutboundTestForm";

const EmailTest = () => (
  <div>
    <h1 style={{ marginBottom: "2rem", color: "#2c3e50" }}>Email test</h1>
    <p
      style={{
        marginTop: "-1.25rem",
        marginBottom: "1.5rem",
        color: "#7f8c8d",
      }}
    >
      Send a test email using the same template list as voice
    </p>
    <OutboundTestForm
      mode="email"
      title="Send test email"
      icon={FiMail}
      accentColor="#2980b9"
      submitLabel="Send test email"
      sendingLabel="Sending..."
      successMessage="Test email request submitted successfully!"
    />
  </div>
);

export default EmailTest;
